import type { Icon as PhosphorIcon } from '@phosphor-icons/react'
// One import per icon, not the barrel: it loads all ~1,500 icons, which internal-frontend's vm test pool then
// evaluates again for every test file, about 120ms each
import { AddressBookIcon } from '@phosphor-icons/react/dist/csr/AddressBook'
import { AirplaneIcon } from '@phosphor-icons/react/dist/csr/Airplane'
import { AirplaneTakeoffIcon } from '@phosphor-icons/react/dist/csr/AirplaneTakeoff'
import { AirplaneTiltIcon } from '@phosphor-icons/react/dist/csr/AirplaneTilt'
import { ArrowBendUpLeftIcon } from '@phosphor-icons/react/dist/csr/ArrowBendUpLeft'
import { ArrowCircleUpIcon } from '@phosphor-icons/react/dist/csr/ArrowCircleUp'
import { ArrowCounterClockwiseIcon } from '@phosphor-icons/react/dist/csr/ArrowCounterClockwise'
import { ArrowDownIcon } from '@phosphor-icons/react/dist/csr/ArrowDown'
import { ArrowLeftIcon } from '@phosphor-icons/react/dist/csr/ArrowLeft'
import { ArrowLineDownIcon } from '@phosphor-icons/react/dist/csr/ArrowLineDown'
import { ArrowLineUpIcon } from '@phosphor-icons/react/dist/csr/ArrowLineUp'
import { ArrowRightIcon } from '@phosphor-icons/react/dist/csr/ArrowRight'
import { ArrowSquareOutIcon } from '@phosphor-icons/react/dist/csr/ArrowSquareOut'
import { ArrowsClockwiseIcon } from '@phosphor-icons/react/dist/csr/ArrowsClockwise'
import { ArrowsDownUpIcon } from '@phosphor-icons/react/dist/csr/ArrowsDownUp'
import { ArrowsLeftRightIcon } from '@phosphor-icons/react/dist/csr/ArrowsLeftRight'
import { ArrowsOutIcon } from '@phosphor-icons/react/dist/csr/ArrowsOut'
import { ArrowsOutCardinalIcon } from '@phosphor-icons/react/dist/csr/ArrowsOutCardinal'
import { ArrowsOutSimpleIcon } from '@phosphor-icons/react/dist/csr/ArrowsOutSimple'
import { ArrowUpIcon } from '@phosphor-icons/react/dist/csr/ArrowUp'
import { BarcodeIcon } from '@phosphor-icons/react/dist/csr/Barcode'
import { BellIcon } from '@phosphor-icons/react/dist/csr/Bell'
import { BellRingingIcon } from '@phosphor-icons/react/dist/csr/BellRinging'
import { BicycleIcon } from '@phosphor-icons/react/dist/csr/Bicycle'
import { BuildingApartmentIcon } from '@phosphor-icons/react/dist/csr/BuildingApartment'
import { BuildingsIcon } from '@phosphor-icons/react/dist/csr/Buildings'
import { CalculatorIcon } from '@phosphor-icons/react/dist/csr/Calculator'
import { CalendarIcon } from '@phosphor-icons/react/dist/csr/Calendar'
import { CalendarXIcon } from '@phosphor-icons/react/dist/csr/CalendarX'
import { CarIcon } from '@phosphor-icons/react/dist/csr/Car'
import { CaretDownIcon } from '@phosphor-icons/react/dist/csr/CaretDown'
import { CaretLeftIcon } from '@phosphor-icons/react/dist/csr/CaretLeft'
import { CaretRightIcon } from '@phosphor-icons/react/dist/csr/CaretRight'
import { CaretUpIcon } from '@phosphor-icons/react/dist/csr/CaretUp'
import { CaretUpDownIcon } from '@phosphor-icons/react/dist/csr/CaretUpDown'
import { ChartBarIcon } from '@phosphor-icons/react/dist/csr/ChartBar'
import { ChartLineUpIcon } from '@phosphor-icons/react/dist/csr/ChartLineUp'
import { ChatCenteredTextIcon } from '@phosphor-icons/react/dist/csr/ChatCenteredText'
import { ChatCircleDotsIcon } from '@phosphor-icons/react/dist/csr/ChatCircleDots'
import { ChatTextIcon } from '@phosphor-icons/react/dist/csr/ChatText'
import { CheckIcon } from '@phosphor-icons/react/dist/csr/Check'
import { CheckCircleIcon } from '@phosphor-icons/react/dist/csr/CheckCircle'
import { CircleIcon } from '@phosphor-icons/react/dist/csr/Circle'
import { CircleNotchIcon } from '@phosphor-icons/react/dist/csr/CircleNotch'
import { ClipboardIcon } from '@phosphor-icons/react/dist/csr/Clipboard'
import { ClipboardTextIcon } from '@phosphor-icons/react/dist/csr/ClipboardText'
import { ClockIcon } from '@phosphor-icons/react/dist/csr/Clock'
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react/dist/csr/ClockCounterClockwise'
import { CoffeeIcon } from '@phosphor-icons/react/dist/csr/Coffee'
import { CopyIcon } from '@phosphor-icons/react/dist/csr/Copy'
import { CreditCardIcon } from '@phosphor-icons/react/dist/csr/CreditCard'
import { CrosshairIcon } from '@phosphor-icons/react/dist/csr/Crosshair'
import { CurrencyDollarIcon } from '@phosphor-icons/react/dist/csr/CurrencyDollar'
import { DesktopIcon } from '@phosphor-icons/react/dist/csr/Desktop'
import { DeviceMobileIcon } from '@phosphor-icons/react/dist/csr/DeviceMobile'
import { DotsSixVerticalIcon } from '@phosphor-icons/react/dist/csr/DotsSixVertical'
import { DotsThreeOutlineIcon } from '@phosphor-icons/react/dist/csr/DotsThreeOutline'
import { DotsThreeOutlineVerticalIcon } from '@phosphor-icons/react/dist/csr/DotsThreeOutlineVertical'
import { DotsThreeVerticalIcon } from '@phosphor-icons/react/dist/csr/DotsThreeVertical'
import { DownloadSimpleIcon } from '@phosphor-icons/react/dist/csr/DownloadSimple'
import { EnvelopeIcon } from '@phosphor-icons/react/dist/csr/Envelope'
import { ExclamationMarkIcon } from '@phosphor-icons/react/dist/csr/ExclamationMark'
import { EyeIcon } from '@phosphor-icons/react/dist/csr/Eye'
import { EyeSlashIcon } from '@phosphor-icons/react/dist/csr/EyeSlash'
import { FileIcon } from '@phosphor-icons/react/dist/csr/File'
import { FileArrowDownIcon } from '@phosphor-icons/react/dist/csr/FileArrowDown'
import { FileArrowUpIcon } from '@phosphor-icons/react/dist/csr/FileArrowUp'
import { FileMagnifyingGlassIcon } from '@phosphor-icons/react/dist/csr/FileMagnifyingGlass'
import { FilePlusIcon } from '@phosphor-icons/react/dist/csr/FilePlus'
import { FileTextIcon } from '@phosphor-icons/react/dist/csr/FileText'
import { FileXlsIcon } from '@phosphor-icons/react/dist/csr/FileXls'
import { FlagIcon } from '@phosphor-icons/react/dist/csr/Flag'
import { FlagCheckeredIcon } from '@phosphor-icons/react/dist/csr/FlagCheckered'
import { FlowArrowIcon } from '@phosphor-icons/react/dist/csr/FlowArrow'
import { FunnelIcon } from '@phosphor-icons/react/dist/csr/Funnel'
import { GaugeIcon } from '@phosphor-icons/react/dist/csr/Gauge'
import { GearIcon } from '@phosphor-icons/react/dist/csr/Gear'
import { HandDepositIcon } from '@phosphor-icons/react/dist/csr/HandDeposit'
import { HandshakeIcon } from '@phosphor-icons/react/dist/csr/Handshake'
import { HashIcon } from '@phosphor-icons/react/dist/csr/Hash'
import { HeadsetIcon } from '@phosphor-icons/react/dist/csr/Headset'
import { HeartIcon } from '@phosphor-icons/react/dist/csr/Heart'
import { HourglassMediumIcon } from '@phosphor-icons/react/dist/csr/HourglassMedium'
import { HouseIcon } from '@phosphor-icons/react/dist/csr/House'
import { IdentificationCardIcon } from '@phosphor-icons/react/dist/csr/IdentificationCard'
import { InfinityIcon } from '@phosphor-icons/react/dist/csr/Infinity'
import { InfoIcon } from '@phosphor-icons/react/dist/csr/Info'
import { InvoiceIcon } from '@phosphor-icons/react/dist/csr/Invoice'
import { LightbulbIcon } from '@phosphor-icons/react/dist/csr/Lightbulb'
import { LinkIcon } from '@phosphor-icons/react/dist/csr/Link'
import { LinkBreakIcon } from '@phosphor-icons/react/dist/csr/LinkBreak'
import { ListIcon } from '@phosphor-icons/react/dist/csr/List'
import { ListBulletsIcon } from '@phosphor-icons/react/dist/csr/ListBullets'
import { LockIcon } from '@phosphor-icons/react/dist/csr/Lock'
import { LockOpenIcon } from '@phosphor-icons/react/dist/csr/LockOpen'
import { MagnifyingGlassIcon } from '@phosphor-icons/react/dist/csr/MagnifyingGlass'
import { MagnifyingGlassPlusIcon } from '@phosphor-icons/react/dist/csr/MagnifyingGlassPlus'
import { MapPinIcon } from '@phosphor-icons/react/dist/csr/MapPin'
import { MapTrifoldIcon } from '@phosphor-icons/react/dist/csr/MapTrifold'
import { MinusIcon } from '@phosphor-icons/react/dist/csr/Minus'
import { MinusCircleIcon } from '@phosphor-icons/react/dist/csr/MinusCircle'
import { MoneyIcon } from '@phosphor-icons/react/dist/csr/Money'
import { MotorcycleIcon } from '@phosphor-icons/react/dist/csr/Motorcycle'
import { NoteIcon } from '@phosphor-icons/react/dist/csr/Note'
import { NotepadIcon } from '@phosphor-icons/react/dist/csr/Notepad'
import { OvenIcon } from '@phosphor-icons/react/dist/csr/Oven'
import { PackageIcon } from '@phosphor-icons/react/dist/csr/Package'
import { PaperPlaneRightIcon } from '@phosphor-icons/react/dist/csr/PaperPlaneRight'
import { PaperPlaneTiltIcon } from '@phosphor-icons/react/dist/csr/PaperPlaneTilt'
import { PathIcon } from '@phosphor-icons/react/dist/csr/Path'
import { PencilSimpleIcon } from '@phosphor-icons/react/dist/csr/PencilSimple'
import { PersonIcon } from '@phosphor-icons/react/dist/csr/Person'
import { PhoneIcon } from '@phosphor-icons/react/dist/csr/Phone'
import { PlayIcon } from '@phosphor-icons/react/dist/csr/Play'
import { PlayCircleIcon } from '@phosphor-icons/react/dist/csr/PlayCircle'
import { PlugIcon } from '@phosphor-icons/react/dist/csr/Plug'
import { PlusIcon } from '@phosphor-icons/react/dist/csr/Plus'
import { PlusCircleIcon } from '@phosphor-icons/react/dist/csr/PlusCircle'
import { PolygonIcon } from '@phosphor-icons/react/dist/csr/Polygon'
import { PrinterIcon } from '@phosphor-icons/react/dist/csr/Printer'
import { ProhibitIcon } from '@phosphor-icons/react/dist/csr/Prohibit'
import { QuestionIcon } from '@phosphor-icons/react/dist/csr/Question'
import { ReceiptIcon } from '@phosphor-icons/react/dist/csr/Receipt'
import { RecycleIcon } from '@phosphor-icons/react/dist/csr/Recycle'
import { RocketLaunchIcon } from '@phosphor-icons/react/dist/csr/RocketLaunch'
import { ScanIcon } from '@phosphor-icons/react/dist/csr/Scan'
import { ShareNetworkIcon } from '@phosphor-icons/react/dist/csr/ShareNetwork'
import { ShuffleIcon } from '@phosphor-icons/react/dist/csr/Shuffle'
import { SignOutIcon } from '@phosphor-icons/react/dist/csr/SignOut'
import { SlidersIcon } from '@phosphor-icons/react/dist/csr/Sliders'
import { SmileyIcon } from '@phosphor-icons/react/dist/csr/Smiley'
import { SmileySadIcon } from '@phosphor-icons/react/dist/csr/SmileySad'
import { SparkleIcon } from '@phosphor-icons/react/dist/csr/Sparkle'
import { StackIcon } from '@phosphor-icons/react/dist/csr/Stack'
import { StackPlusIcon } from '@phosphor-icons/react/dist/csr/StackPlus'
import { StackSimpleIcon } from '@phosphor-icons/react/dist/csr/StackSimple'
import { StampIcon } from '@phosphor-icons/react/dist/csr/Stamp'
import { StarIcon } from '@phosphor-icons/react/dist/csr/Star'
import { SteeringWheelIcon } from '@phosphor-icons/react/dist/csr/SteeringWheel'
import { StorefrontIcon } from '@phosphor-icons/react/dist/csr/Storefront'
import { SuitcaseIcon } from '@phosphor-icons/react/dist/csr/Suitcase'
import { TableIcon } from '@phosphor-icons/react/dist/csr/Table'
import { TagIcon } from '@phosphor-icons/react/dist/csr/Tag'
import { TelevisionIcon } from '@phosphor-icons/react/dist/csr/Television'
import { ThumbsDownIcon } from '@phosphor-icons/react/dist/csr/ThumbsDown'
import { ThumbsUpIcon } from '@phosphor-icons/react/dist/csr/ThumbsUp'
import { TimerIcon } from '@phosphor-icons/react/dist/csr/Timer'
import { TrashIcon } from '@phosphor-icons/react/dist/csr/Trash'
import { TreePalmIcon } from '@phosphor-icons/react/dist/csr/TreePalm'
import { TreeStructureIcon } from '@phosphor-icons/react/dist/csr/TreeStructure'
import { TrendUpIcon } from '@phosphor-icons/react/dist/csr/TrendUp'
import { TrolleyIcon } from '@phosphor-icons/react/dist/csr/Trolley'
import { TruckIcon } from '@phosphor-icons/react/dist/csr/Truck'
import { TruckTrailerIcon } from '@phosphor-icons/react/dist/csr/TruckTrailer'
import { UserIcon } from '@phosphor-icons/react/dist/csr/User'
import { UserCheckIcon } from '@phosphor-icons/react/dist/csr/UserCheck'
import { UserGearIcon } from '@phosphor-icons/react/dist/csr/UserGear'
import { UserMinusIcon } from '@phosphor-icons/react/dist/csr/UserMinus'
import { UsersIcon } from '@phosphor-icons/react/dist/csr/Users'
import { VanIcon } from '@phosphor-icons/react/dist/csr/Van'
import { WarehouseIcon } from '@phosphor-icons/react/dist/csr/Warehouse'
import { WarningIcon } from '@phosphor-icons/react/dist/csr/Warning'
import { WarningCircleIcon } from '@phosphor-icons/react/dist/csr/WarningCircle'
import { WashingMachineIcon } from '@phosphor-icons/react/dist/csr/WashingMachine'
import { XIcon } from '@phosphor-icons/react/dist/csr/X'
import { XCircleIcon } from '@phosphor-icons/react/dist/csr/XCircle'
import { Refrigerator } from './drawn/Refrigerator'
import { SortDown } from './drawn/SortDown'
import { SortUp } from './drawn/SortUp'
import { TumbleDryer } from './drawn/TumbleDryer'
import type { IconName } from './names'

export const icons: Record<IconName, PhosphorIcon> = {
  'address-book': AddressBookIcon,
  'angle-down': CaretDownIcon,
  'angle-right': CaretRightIcon,
  'angle-up': CaretUpIcon,
  apartment: BuildingApartmentIcon,
  'arrow-circle-up': ArrowCircleUpIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-from-bottom': ArrowLineUpIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-progress': FlowArrowIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-right-arrow-left': ArrowsLeftRightIcon,
  'arrow-right-from-bracket': SignOutIcon,
  'arrow-rotate-backward': ArrowCounterClockwiseIcon,
  'arrow-to-bottom': ArrowLineDownIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-up-arrow-down': ArrowsDownUpIcon,
  'arrow-up-right-from-square': ArrowSquareOutIcon,
  arrows: ArrowsOutCardinalIcon,
  'arrows-rotate': ArrowsClockwiseIcon,
  'arrows-up-down': ArrowsDownUpIcon,
  ban: ProhibitIcon,
  'barcode-read': BarcodeIcon,
  bars: ListIcon,
  bell: BellIcon,
  'bell-on': BellRingingIcon,
  bicycle: BicycleIcon,
  box: PackageIcon,
  'box-check': CheckCircleIcon,
  calculator: CalculatorIcon,
  'calculator-simple': CalculatorIcon,
  calendar: CalendarIcon,
  'calendar-alt': CalendarIcon,
  'calendar-times': CalendarXIcon,
  'calendar-xmark': CalendarXIcon,
  'car-side': CarIcon,
  'chart-bar': ChartBarIcon,
  'chart-column': ChartBarIcon,
  check: CheckIcon,
  'check-circle': CheckCircleIcon,
  'chevron-down': CaretDownIcon,
  'chevron-left': CaretLeftIcon,
  'chevron-right': CaretRightIcon,
  'chevron-up': CaretUpIcon,
  circle: CircleIcon,
  'circle-arrow-up': ArrowCircleUpIcon,
  'circle-info': InfoIcon,
  'circle-play': PlayCircleIcon,
  clipboard: ClipboardIcon,
  'clipboard-check': ClipboardTextIcon,
  clock: ClockIcon,
  'clock-rotate-left': ClockCounterClockwiseIcon,
  clone: CopyIcon,
  close: XIcon,
  coffee: CoffeeIcon,
  cog: GearIcon,
  'comment-alt-edit': ChatTextIcon,
  'comment-check': ChatCenteredTextIcon,
  'conveyor-belt-boxes': PackageIcon,
  copy: CopyIcon,
  'credit-card': CreditCardIcon,
  crosshairs: CrosshairIcon,
  desktop: DesktopIcon,
  'display-chart-up': ChartLineUpIcon,
  'dollar-sign': CurrencyDollarIcon,
  dolly: TrolleyIcon,
  'dots-three-vertical': DotsThreeVerticalIcon,
  'down-from-line': ArrowLineDownIcon,
  download: DownloadSimpleIcon,
  'draw-polygon': PolygonIcon,
  'dryer-heat': TumbleDryer,
  'ellipsis-h': DotsThreeOutlineIcon,
  'ellipsis-v': DotsThreeOutlineVerticalIcon,
  envelope: EnvelopeIcon,
  'exchange-alt': ArrowsLeftRightIcon,
  exclamation: ExclamationMarkIcon,
  'exclamation-circle': WarningCircleIcon,
  'exclamation-triangle': WarningIcon,
  expand: ArrowsOutSimpleIcon,
  'expand-arrows': ArrowsOutCardinalIcon,
  'external-link': ArrowSquareOutIcon,
  eye: EyeIcon,
  'eye-slash': EyeSlashIcon,
  file: FileIcon,
  'file-export': FileArrowUpIcon,
  'file-import': FileArrowDownIcon,
  'file-invoice': InvoiceIcon,
  'file-invoice-dollar': InvoiceIcon,
  'file-lines': FileTextIcon,
  'file-magnifying-glass': FileMagnifyingGlassIcon,
  'file-plus': FilePlusIcon,
  'file-spreadsheet': FileXlsIcon,
  filter: FunnelIcon,
  flag: FlagIcon,
  'flag-checkered': FlagCheckeredIcon,
  frown: SmileySadIcon,
  gauge: GaugeIcon,
  gear: GearIcon,
  'grip-dots-vertical': DotsSixVerticalIcon,
  'grip-vertical': DotsSixVerticalIcon,
  'hand-holding-box': HandDepositIcon,
  handshake: HandshakeIcon,
  hashtag: HashIcon,
  headset: HeadsetIcon,
  heart: HeartIcon,
  history: ClockCounterClockwiseIcon,
  'hourglass-half': HourglassMediumIcon,
  house: HouseIcon,
  'house-building': BuildingsIcon,
  'id-card': IdentificationCardIcon,
  infinity: InfinityIcon,
  'info-circle': InfoIcon,
  'layer-group': StackSimpleIcon,
  'layer-plus': StackPlusIcon,
  lightbulb: LightbulbIcon,
  link: LinkIcon,
  list: ListBulletsIcon,
  'location-dot': MapPinIcon,
  'location-dot-slash': MapPinIcon,
  lock: LockIcon,
  'lock-keyhole': LockIcon,
  'lock-keyhole-open': LockOpenIcon,
  'lock-open': LockOpenIcon,
  'magnifying-glass': MagnifyingGlassIcon,
  male: PersonIcon,
  map: MapTrifoldIcon,
  'map-marked-alt': MapTrifoldIcon,
  'map-marker': MapPinIcon,
  'map-marker-alt': MapPinIcon,
  'map-marker-alt-slash': MapPinIcon,
  'map-marker-check': MapPinIcon,
  maximize: ArrowsOutIcon,
  'memo-circle-info': NotepadIcon,
  'message-exclamation': ChatCircleDotsIcon,
  minus: MinusIcon,
  'minus-circle': MinusCircleIcon,
  'mobile-button': DeviceMobileIcon,
  'money-bill': MoneyIcon,
  'money-bill-trend-up': TrendUpIcon,
  motorcycle: MotorcycleIcon,
  'mug-hot': CoffeeIcon,
  'mug-saucer': CoffeeIcon,
  oven: OvenIcon,
  pallet: StackIcon,
  'paper-plane': PaperPlaneTiltIcon,
  'paper-plane-top': PaperPlaneRightIcon,
  pen: PencilSimpleIcon,
  pencil: PencilSimpleIcon,
  'pencil-alt': PencilSimpleIcon,
  'person-dolly': TrolleyIcon,
  phone: PhoneIcon,
  plane: AirplaneIcon,
  'plane-circle-check': AirplaneTiltIcon,
  'plane-departure': AirplaneTakeoffIcon,
  play: PlayIcon,
  plug: PlugIcon,
  plus: PlusIcon,
  'plus-circle': PlusCircleIcon,
  'postage-stamp': StampIcon,
  print: PrinterIcon,
  'question-circle': QuestionIcon,
  random: ShuffleIcon,
  receipt: ReceiptIcon,
  recycle: RecycleIcon,
  refrigerator: Refrigerator,
  reply: ArrowBendUpLeftIcon,
  'rocket-launch': RocketLaunchIcon,
  route: PathIcon,
  scanner: ScanIcon,
  search: MagnifyingGlassIcon,
  'search-plus': MagnifyingGlassPlusIcon,
  'share-nodes': ShareNetworkIcon,
  'shipping-fast': TruckIcon,
  shuffle: ShuffleIcon,
  'shuttle-van': VanIcon,
  'sign-out': SignOutIcon,
  'sign-out-alt': SignOutIcon,
  sitemap: TreeStructureIcon,
  'sliders-up': SlidersIcon,
  'smile-beam': SmileyIcon,
  sort: CaretUpDownIcon,
  'sort-down': SortDown,
  'sort-up': SortUp,
  sparkles: SparkleIcon,
  spinner: CircleNotchIcon,
  'spinner-third': CircleNotchIcon,
  star: StarIcon,
  stars: SparkleIcon,
  'steering-wheel': SteeringWheelIcon,
  'sticky-note': NoteIcon,
  stopwatch: TimerIcon,
  store: StorefrontIcon,
  suitcase: SuitcaseIcon,
  'sync-alt': ArrowsClockwiseIcon,
  table: TableIcon,
  'tachometer-average': GaugeIcon,
  'tachometer-fastest': GaugeIcon,
  'tachometer-slow': GaugeIcon,
  'tachometer-slowest': GaugeIcon,
  tags: TagIcon,
  'thumbs-down': ThumbsDownIcon,
  'thumbs-up': ThumbsUpIcon,
  times: XIcon,
  'times-circle': XCircleIcon,
  trash: TrashIcon,
  'trash-alt': TrashIcon,
  'trash-can': TrashIcon,
  'tree-palm': TreePalmIcon,
  'triangle-exclamation': WarningIcon,
  truck: TruckIcon,
  'truck-fast': TruckIcon,
  'truck-moving': TruckTrailerIcon,
  tv: TelevisionIcon,
  unlink: LinkBreakIcon,
  'up-down-left-right': ArrowsOutCardinalIcon,
  'up-from-line': ArrowLineUpIcon,
  user: UserIcon,
  'user-alt': UserIcon,
  'user-check': UserCheckIcon,
  'user-gear': UserGearIcon,
  'user-headset': HeadsetIcon,
  'user-pen': UserGearIcon,
  'user-xmark': UserMinusIcon,
  users: UsersIcon,
  'van-shuttle': VanIcon,
  warehouse: WarehouseIcon,
  'warehouse-alt': WarehouseIcon,
  'warehouse-full': WarehouseIcon,
  'warehouse-regular': WarehouseIcon,
  warning: WarningIcon,
  'washing-machine': WashingMachineIcon,
  xmark: XIcon
}
